import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SignInForm from '../components/signInForm';
import SignUpForm from '../components/signUpForm';
import ResetForm from '../components/resetForm';
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography';
import { signInFn, signUpFn,resetFn,getRandomCode } from "../reducers/user";
import Message from '../../../uis/tip/snackbars'

import './sign_in.css'

function TabContainer({ children}) {
    return (
        <Typography component="div" style={{ padding: 6 * 3 }}>
            {children}
        </Typography>
    )
}
TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
}

class SignIn extends React.Component {
    constructor(props) {
        super(props);
        this.handleSignIn = this.handleSignIn.bind(this)
        this.handleSignUp = this.handleSignUp.bind(this)
        this.handleReset = this.handleReset.bind(this)
    }
    componentDidMount() {
        const {dispatch} = this.props
        dispatch(getRandomCode())
    }
    handleChange = (e,value) => {
        this.context.router.history.push(`${value}`)
    }
    handleSignIn(formData) {
        formData = {
            phone: formData.phone,
            password: formData.password,
            loginCode: formData.code
        }
        return this.props.dispatch(signInFn(formData))
    }
    handleSignUp(formData) {
        formData = {
            name: formData.username,
            phone: formData.phone,
            password: formData.password,
            code: formData.verification
        }
        return this.props.dispatch(signUpFn(formData))
    }
    handleReset(formData) {
        formData = {
            phone: formData.phone,
            password: formData.newpassword,
            code: formData.verification
        }
        return this.props.dispatch(resetFn(formData))
    }
    changeCode = () => {
        const { dispatch } = this.props
        dispatch(getRandomCode())
    }
     render() {
        const paperStyle = { width: 500,borderRadius: 5 }
        const {location: { pathname},checkCode} = this.props;
        return (
            <div className="loginPage">
                <Paper style={paperStyle}>
                    <AppBar position="static" style={{background: "linear-gradient(to right, #F96487 , #1627b7)",borderRadius: 5}}>
                        <Tabs
                            value={pathname}
                            textColor="inherit"
                            onChange={this.handleChange}
                            indicatorColor="secondary"
                            fullWidth
                        >
                            <Tab label="登录" value="/sign/sign-in"/>
                            {/* <Tab label="注册"value="/sign/sign-up" /> */}
                            <Tab label="忘记密码" value="/sign/reset" />
                        </Tabs>
                    </AppBar>
                    {pathname === '/sign/sign-in' &&  
                        <TabContainer>
                            <SignInForm 
                                onSubmit={this.handleSignIn}
                                checkCode={checkCode}
                                changeCode={this.changeCode}
                            />
                        </TabContainer>}   
                    {pathname === '/sign/sign-up' &&
                        <TabContainer>
                            <SignUpForm 
                                onSubmit={this.handleSignUp}
                            />
                        </TabContainer>}    
                    {pathname === '/sign/reset' && 
                        <TabContainer>
                            <ResetForm 
                                onSubmit={this.handleReset}
                            />
                        </TabContainer>}
                </Paper>
                <Message />
            </div> 
        )
    }   
}
SignIn.contextTypes = {
    router: PropTypes.object.isRequired
}
const mapStateToProps = state => {
    return {
        checkCode: state.auth.user.checkCode
    }
}
export default connect(mapStateToProps)(SignIn);


// WEBPACK FOOTER //
// ./src/pages/sign/containers/sign_in.js